import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { Text } from "@ps-design-system/components/Text";
import Group24 from "@ps-design-system/icons/Group/Group24";

import { trackReferVendorButtonClicked } from "../../app-host-hub/analytics/host-hub-analytics";

const ReferVendor = () => {
  const handleReferClick = () => {
    trackReferVendorButtonClicked({
      buttonName: "refer a vendor",
      buttonLocation: "my listings vendor",
    });
  };
  return (
    <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-between tw-border tw-border-gray-300 tw-rounded-4 tw-p-24 tw-mt-20 tw-mb-56">
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-20 tw-items-center tw-text-center md:tw-text-left">
        <div className="tw-size-44 tw-flex tw-items-center tw-justify-center tw-bg-purple-200 tw-rounded-circular">
          <Group24 />
        </div>
        <div className="tw-mb-20 md:tw-mb-0">
          <Text
            typeface="headline-1-m"
            element="h3"
            className="tw-mt-0 tw-mb-2"
          >
            <FormattedMessage
              id="vendor.refer.title"
              defaultMessage="Who's in your network?"
            />
          </Text>
          <Text typeface="body-1">
            <FormattedMessage
              id="vendor.refer.desc"
              defaultMessage="Refer vendors you love working with and they’ll become a trusted
            collaborator."
            />
          </Text>
        </div>
      </div>
      <Button
        className="tw-w-full md:tw-w-auto"
        appearance="white"
        variant="outline-1"
        href="https://hosts.trypeerspace.com/vendor-to-vendor-recommendations"
        target="_blank"
        rel="noopener"
        onClick={handleReferClick}
      >
        <Text typeface="body-2-m">
          <FormattedMessage
            id="vendor.refer.btn"
            defaultMessage="Refer a vendor"
          />
        </Text>
      </Button>
    </div>
  );
};

export default ReferVendor;
